import axios from '@/api/axios'

const createAthleteScholarship = athleteScholarship => {
  return axios.post('/athleteScholarship', athleteScholarship)
}

const getAthletesScholarship = () => {
  return axios.get('/athleteScholarship')
}

const getAthleteScholarship = id => {
  return axios.get(`/athleteScholarship/${id}`)
}

const updateAthleteScholarship = (id, athleteScholarshipInput) => {
  return axios.put(`/athleteScholarship/${id}`, athleteScholarshipInput)
}

const deleteAthleteScholarship = id => {
  return axios.delete(`/athleteScholarship/${id}`)
}

const getAthleteScholarshipParams = params => {
  return axios.get(`/athleteScholarship${params}`).then(res => res.data)
}

export default {
  createAthleteScholarship,
  getAthletesScholarship,
  getAthleteScholarship,
  updateAthleteScholarship,
  deleteAthleteScholarship,
  getAthleteScholarshipParams
}
